import Icon from '../components/Icon.vue'

Icon.register({
  'long-arrow-alt-left': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M134.1 296v46.1c0 21.4-25.9 32.1-41 17l-86.1-86.1c-9.4-9.4-9.4-24.6 0-33.9l86.1-86.1c15.1-15.1 41-4.4 41 17v46.1h301.9c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12h-301.9z'
      }
    ]
  }
})
